import { Link } from "react-router-dom";
import './OC.css';

const WORLDS = [
  { name: "VANDALISM101", background: "VANDALISM101 background.webp", alt: "Logo of VANDALISM101" },
  { name: "무연고장례", background: "무연고장례 background.webp", alt: "Logo of 무연고장례(Necrocomiche)" },
  { name: "Residents of AION", background: "Residents of AION Background.webp", alt: "Logo of Residents of AION" },
];

function OCList() {
  return (
    <div className="OCList">
      <ul className="hide-scrollbar">
        {WORLDS.map(world => (
          <li key={world.name} style={{backgroundImage: `url("/${world.name}/${world.background}")`}}>
            <Link to={`/OC/${world.name}`}>
              <img src={`/${world.name}/${world.name} logo.webp`} alt={world.alt}/>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default OCList;
